import React from "react";

export default function StatsCard({ title, value, icon, color }) {
  // STATIC MAPPED COLORS (Tailwind-safe)
  const colorMap = {
    emerald: {
      bubble: "bg-emerald-50 text-emerald-600",
      title: "text-emerald-700",
    },
    blue: {
      bubble: "bg-blue-50 text-blue-600",
      title: "text-blue-700",
    },
    violet: {
      bubble: "bg-violet-50 text-violet-600",
      title: "text-violet-700",
    },
    red: {
      bubble: "bg-red-50 text-red-600",
      title: "text-red-700",
    },
    orange: {
      bubble: "bg-orange-50 text-orange-600",
      title: "text-orange-700",
    },
    yellow: {
      bubble: "bg-yellow-50 text-yellow-600",
      title: "text-yellow-700",
    },
    gray: {
      bubble: "bg-gray-100 text-gray-600",
      title: "text-gray-700",
    },
  };

  // fallback
  const palette = colorMap[color] || colorMap["emerald"];

  // detect if JSX or component
  const RenderIcon =
    typeof icon === "function" ? <icon size={14} /> : icon;

  return (
    <div className="inline-flex items-center gap-2 rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 whitespace-nowrap shadow-sm">

      {/* Icon bubble */}
      <div className={`grid h-7 w-7 place-items-center rounded-lg ${palette.bubble}`}>
        {RenderIcon}
      </div>

      {/* Text */}
      <div className="flex flex-col leading-tight">
        <span className={`text-[10px] font-semibold uppercase tracking-wide ${palette.title}`}>
          {title}
        </span>
        <span className="text-xs font-semibold text-gray-900">
          {value}
        </span>
      </div>

    </div>
  );
}
